// extracted by mini-css-extract-plugin
module.exports = {"borderTop":"TimetableSidebar_borderTop_22RGW"};